// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PiC-2","input":"styles_input__1iS3w"};